document.querySelectorAll('.compare-expand-btn').forEach(function(button) {
  button.addEventListener('click', function() {
    const allWrappers = document.querySelectorAll('.compare-product-wrapper');
    const allButtons = document.querySelectorAll('.compare-expand-btn');

    const firstRows = allWrappers[0].querySelectorAll('tr:nth-child(n+4)');
    const isOpening = firstRows[0].style.opacity !== '1';

    allWrappers.forEach(function(wrapper) {
      const rows = wrapper.querySelectorAll('tr:nth-child(n+4)');
      rows.forEach(function(tr) {
        
        if (isOpening) {
          tr.style.opacity = '1';
          tr.style.maxHeight = '150px';
          tr.style.overflow = 'hidden';
        } else {
          tr.style.opacity = '0';
          tr.style.maxHeight = '';
          tr.style.overflow = '';
        }
      });
    });

    allButtons.forEach(function(btn) {
      if (isOpening) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  });
});

// Compare product slider
document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.compare-product-slider');
    if(!slider) return;

    function toggleSlick() {
    if(window.innerWidth < 767){
        if(!slider.classList.contains('slick-initialized')){
        $(slider).slick({
            dots:false,
            arrows:false,
            slidesToShow:1.7,
            slidesToScroll:1,
            infinite:false
        });
        }
    } else {
        if(slider.classList.contains('slick-initialized')){
        $(slider).slick('unslick');
        }
    }
    }

    toggleSlick();
    window.addEventListener('resize', toggleSlick);
});